import { Component, Input, OnInit } from '@angular/core';
import { ObservationByObserver } from 'src/app/performance-dashboard/model/performance.model';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-observation-by-observer',
  templateUrl: './observation-by-observer.component.html',
  styleUrls: ['./observation-by-observer.component.css']
})
export class ObservationByObserverComponent implements OnInit {
  @Input() ObservationByObserverData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedObservationByObserverData: { [s: string]: ObservationByObserver } = {};
  rowGroupMetadata: {};
  ObsByObserverData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) {

  }

  ngOnInit(): void {
    this.updateRowGroupMetaData();
  }

  onRowEditInit(observationByObserver: ObservationByObserver) {
    this.clonedObservationByObserverData[observationByObserver.Id] = { ...observationByObserver };
    this.DisableExport = true;
  }

  onRowEditSave(observationByObserver: ObservationByObserver, index: number) {
    if (observationByObserver) {
      this.ObservationByObserverData[index].Total = observationByObserver.Jan + observationByObserver.Feb + observationByObserver.Mar + observationByObserver.Apr + observationByObserver.May + observationByObserver.Jun + observationByObserver.Jul + observationByObserver.Aug + observationByObserver.Sep + observationByObserver.Oct + observationByObserver.Nov + observationByObserver.Dec;

      delete this.clonedObservationByObserverData[observationByObserver.Id];
      //this.messageService.add({severity:'success', summary: 'Success', detail:'Product is updated'});
    } else {
      //this.messageService.add({severity:'error', summary: 'Error', detail:'Invalid Price'});
    }
    this.DisableExport = Object.keys(this.clonedObservationByObserverData).length > 0 ? true : false;
  }

  onRowEditCancel(observationByObserver: ObservationByObserver, index: number) {
    this.ObservationByObserverData[index] = this.clonedObservationByObserverData[observationByObserver.Id];
    delete this.clonedObservationByObserverData[observationByObserver.Id];
    this.DisableExport = Object.keys(this.clonedObservationByObserverData).length > 0 ? true : false;
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};

    if(this.ObservationByObserverData.length > 0)
    {
      this.ObservationByObserverData = this.ObservationByObserverData[0];
    }
    if (this.ObservationByObserverData) {
        for (let i = 0; i < this.ObservationByObserverData.length; i++) {
            let rowData = this.ObservationByObserverData[i];
            let representativeName = rowData.BaseUnit;

            if (i == 0) {
                this.rowGroupMetadata[representativeName] = { index: 0, size: 1 };
            }
            else {
                let previousRowData = this.ObservationByObserverData[i - 1];
                let previousRowGroup = previousRowData.BaseUnit;
                if (representativeName === previousRowGroup)
                    this.rowGroupMetadata[representativeName].size++;
                else
                    this.rowGroupMetadata[representativeName] = { index: i, size: 1 };
            }
        }
    }
  }

  GetObsByObserverSelectedDetails(UnitId,Unit,Column,User){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Observation By Observer",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit,
        "User":User
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetObsByObserverSelectedDetails.bind(this));
  }
  callbackMethodForGetObsByObserverSelectedDetails(response){
    if(response.Success)
    this.ObsByObserverData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/observation/make-observation/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/observation/make-observation/'+value+';unitId='+UnitId], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('ObservationByObserverTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('P','O');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "ObservationByObserver.xlsx");

  }
  //EOC Pritesh

}
